import {axiosi} from '../../config/axios'
import { getFirestore, collection, query, orderBy, limit, where, getDocs, getDoc , addDoc, doc, updateDoc , serverTimestamp  } from "firebase/firestore";


// export const createOrder=async(order)=>{
//     try {
//         const res=await axiosi.post("/orders",order)
//         return res.data
//     } catch (error) {
//         throw error.response.data
//     }
// }

// export const createOrder = async (order) => {
//     try {
//       const db = getFirestore();
  
//       const payload = {
//         ...order,
//         address: Array.isArray(order.address) ? order.address : [order.address],  // ← ensure array
//         status: "pending",          // <-- DEFAULT ORDER STATUS
//         createdAt: serverTimestamp() // <-- TIMESTAMP
//       };

//       const docRef = await addDoc(collection(db, "orders"), payload);
  
//       return { message: "Order created successfully", _id: docRef.id, ...order };
  
//     } catch (error) {
//       console.error("Error creating order:", error);
//       throw error;
//     }
//   };


export const createOrder = async (order) => {
  try {
      const db = getFirestore();
      console.log('ff',order)
      if (!Array.isArray(order.item) || order.item.length === 0) {
          throw new Error("Order items missing");
      }

      const payload = {
          ...order,
          address: Array.isArray(order.address) ? order.address : [order.address],
          status: "pending",
          createdAt: serverTimestamp()
      };

      const docRef = await addDoc(collection(db, "orders"), payload);

      return {
          message: "Order created successfully",
          _id: docRef.id,
          ...payload
      };

  } catch (error) {
      console.error("Error creating order:", error);
      throw error;
  }
};


// export const getOrderByUserId=async(id)=>{
//     try {
//         const res=await axiosi.get(`/orders/users/${id}`)
//         return res.data
//     } catch (error) {
//         // throw error.response.data
//         return [
//             {
//                 "_id": "65c2658db53f820728d0745a",
//                 "user": "65b8e564ea5ce114184ccb96",
//                 "item": [
//                     {
//                         "user": "65b8e564ea5ce114184ccb96",
//                         "product": {
//                             "_id": "65a7e45902e12c44f5994454",
//                             "title": "Samsung Galaxy Book",
//                             "description": "Samsung Galaxy Book S (2020) Laptop With Intel Lakefield Chip, 8GB of RAM Launched",
//                             "price": 1499,
//                             "discountPercentage": 4.15,
//                             "stockQuantity": 50,
//                             "brand": {
//                                 "_id": "65a7e20102e12c44f59943db",
//                                 "name": "Samsung"
//                             },
//                             "category": "65a7e24602e12c44f599442d",
//                             "thumbnail": "https://cdn.dummyjson.com/product-images/7/thumbnail.jpg",
//                             "images": [
//                                 "https://cdn.dummyjson.com/product-images/7/1.jpg",
//                                 "https://cdn.dummyjson.com/product-images/7/2.jpg",
//                                 "https://cdn.dummyjson.com/product-images/7/3.jpg",
//                                 "https://cdn.dummyjson.com/product-images/7/thumbnail.jpg"
//                             ],
//                             "isDeleted": false,
//                             "updatedAt": "2024-02-05T09:34:30.107Z"
//                         },
//                         "quantity": 1,
//                         "_id": "65c26581b53f820728d07456"
//                     }
//                 ],
//                 "address": [
//                     {
//                         "_id": "65c26398e1e1a2106ac8fbd5",
//                         "user": "65b8e564ea5ce114184ccb96",
//                         "street": "main 11th",
//                         "city": "Indrapuram",
//                         "state": "Uttar Pradesh",
//                         "phoneNumber": "9452571272",
//                         "postalCode": "201012",
//                         "country": "India",
//                         "type": "Home",
//                         "__v": 0
//                     }
//                 ],
//                 "status": "Pending",
//                 "paymentMode": "CARD",
//                 "total": 1509.55,
//                 "createdAt": "2024-02-07T10:36:15.151Z"
//             },
//             {
//                 "_id": "65c265c6b53f820728d0749c",
//                 "user": "65b8e564ea5ce114184ccb96",
//                 "item": [
//                     {
//                         "_id": "65c265a2b53f820728d07474",
//                         "user": "65b8e564ea5ce114184ccb96",
//                         "product": {
//                             "_id": "65a7e45902e12c44f599445d",
//                             "title": "Hyaluronic Acid Serum",
//                             "description": "L'OrÃ©al Paris introduces Hyaluron Expert Replumping Serum formulated with 1.5% Hyaluronic Acid",
//                             "price": 19,
//                             "discountPercentage": 13.31,
//                             "stockQuantity": 110,
//                             "brand": {
//                                 "_id": "65a7e20102e12c44f59943e6",
//                                 "name": "L'Oreal Paris"
//                             },
//                             "category": "65a7e24602e12c44f599442f",
//                             "thumbnail": "https://cdn.dummyjson.com/product-images/16/thumbnail.jpg",
//                             "images": [
//                                 "https://cdn.dummyjson.com/product-images/16/1.png",
//                                 "https://cdn.dummyjson.com/product-images/16/2.webp",
//                                 "https://cdn.dummyjson.com/product-images/16/3.jpg",
//                                 "https://cdn.dummyjson.com/product-images/16/4.jpg",
//                                 "https://cdn.dummyjson.com/product-images/16/thumbnail.jpg"
//                             ],
//                             "isDeleted": false
//                         },
//                         "quantity": 2
//                     },
//                     {
//                         "_id": "65c265b9b53f820728d0748f",
//                         "user": "65b8e564ea5ce114184ccb96",
//                         "product": {
//                             "_id": "65a7e45902e12c44f599445e",
//                             "title": "Tree Oil 30ml",
//                             "description": "Tea tree oil contains a number of compounds, including terpinen-4-ol, that have been shown to kill certain bacteria,",
//                             "price": 12,
//                             "discountPercentage": 4.09,
//                             "stockQuantity": 78,
//                             "brand": {
//                                 "_id": "65a7e20102e12c44f59943e7",
//                                 "name": "Hemani Tea"
//                             },
//                             "category": "65a7e24602e12c44f599442f",
//                             "thumbnail": "https://cdn.dummyjson.com/product-images/17/thumbnail.jpg",
//                             "images": [
//                                 "https://cdn.dummyjson.com/product-images/17/1.jpg",
//                                 "https://cdn.dummyjson.com/product-images/17/2.jpg",
//                                 "https://cdn.dummyjson.com/product-images/17/3.jpg",
//                                 "https://cdn.dummyjson.com/product-images/17/thumbnail.jpg"
//                             ],
//                             "isDeleted": false
//                         },
//                         "quantity": 3
//                     }
//                 ],
//                 "address": [
//                     {
//                         "_id": "65c26398e1e1a2106ac8fbd5",
//                         "user": "65b8e564ea5ce114184ccb96",
//                         "street": "main 11th",
//                         "city": "Indrapuram",
//                         "state": "Uttar Pradesh",
//                         "phoneNumber": "9452571272",
//                         "postalCode": "201012",
//                         "country": "India",
//                         "type": "Home",
//                         "__v": 0
//                     }
//                 ],
//                 "status": "Pending",
//                 "paymentMode": "COD",
//                 "total": 84.55,
//                 "createdAt": "2024-02-07T10:36:15.151Z"
//             },
//             {
//                 "_id": "65c265feb53f820728d074b4",
//                 "user": "65b8e564ea5ce114184ccb96",
//                 "item": [
//                     {
//                         "user": "65b8e564ea5ce114184ccb96",
//                         "product": {
//                             "_id": "65a7e45902e12c44f59944b0",
//                             "title": "American Vintage Wood Pendant Light",
//                             "description": "American Vintage Wood Pendant Light Farmhouse Antique Hanging Lamp Lampara Colgante",
//                             "price": 46,
//                             "discountPercentage": 8.84,
//                             "stockQuantity": 138,
//                             "brand": {
//                                 "_id": "65a7e20102e12c44f5994425",
//                                 "name": "Ifei Home"
//                             },
//                             "category": "65a7e24602e12c44f599443f",
//                             "thumbnail": "https://cdn.dummyjson.com/product-images/99/thumbnail.jpg",
//                             "images": [
//                                 "https://cdn.dummyjson.com/product-images/99/1.jpg",
//                                 "https://cdn.dummyjson.com/product-images/99/2.jpg",
//                                 "https://cdn.dummyjson.com/product-images/99/3.jpg",
//                                 "https://cdn.dummyjson.com/product-images/99/4.jpg",
//                                 "https://cdn.dummyjson.com/product-images/99/thumbnail.jpg"
//                             ],
//                             "isDeleted": false
//                         },
//                         "quantity": 1,
//                         "_id": "65c265edb53f820728d074b0"
//                     }
//                 ],
//                 "address": [
//                     {
//                         "_id": "65c26398e1e1a2106ac8fbd5",
//                         "user": "65b8e564ea5ce114184ccb96",
//                         "street": "main 11th",
//                         "city": "Indrapuram",
//                         "state": "Uttar Pradesh",
//                         "phoneNumber": "9452571272",
//                         "postalCode": "201012",
//                         "country": "India",
//                         "type": "Home",
//                         "__v": 0
//                     }
//                 ],
//                 "status": "Pending",
//                 "paymentMode": "COD",
//                 "total": 56.55,
//                 "createdAt": "2024-02-07T10:36:15.151Z"
//             },
//             {
//                 "_id": "65c2667db53f820728d07579",
//                 "user": "65b8e564ea5ce114184ccb96",
//                 "item": [
//                     {
//                         "_id": "65c26673b53f820728d0756f",
//                         "user": "65b8e564ea5ce114184ccb96",
//                         "product": {
//                             "_id": "65a7e45902e12c44f599446d",
//                             "title": "Sofa for Coffe Cafe",
//                             "description": "Ratttan Outdoor furniture Set Waterproof  Rattan Sofa for Coffe Cafe",
//                             "price": 50,
//                             "discountPercentage": 15.59,
//                             "stockQuantity": 30,
//                             "brand": {
//                                 "_id": "65a7e20102e12c44f59943f6",
//                                 "name": "Ratttan Outdoor"
//                             },
//                             "category": "65a7e24602e12c44f5994432",
//                             "thumbnail": "https://cdn.dummyjson.com/product-images/32/thumbnail.jpg",
//                             "images": [
//                                 "https://cdn.dummyjson.com/product-images/32/1.jpg",
//                                 "https://cdn.dummyjson.com/product-images/32/2.jpg",
//                                 "https://cdn.dummyjson.com/product-images/32/3.jpg",
//                                 "https://cdn.dummyjson.com/product-images/32/thumbnail.jpg"
//                             ],
//                             "isDeleted": false
//                         },
//                         "quantity": 1
//                     }
//                 ],
//                 "address": [
//                     {
//                         "_id": "65c26412e1e1a2106ac8fbd8",
//                         "user": "65b8e564ea5ce114184ccb96",
//                         "street": "main 18th",
//                         "city": "Noida",
//                         "state": "Uttar Pradesh",
//                         "phoneNumber": "9846286159",
//                         "postalCode": "301273",
//                         "country": "India",
//                         "type": "Buisness",
//                         "__v": 0
//                     }
//                 ],
//                 "status": "Pending",
//                 "paymentMode": "CARD",
//                 "total": 60.55,
//                 "createdAt": "2024-02-07T10:36:15.151Z"
//             },
//             {
//                 "_id": "65c266eab53f820728d0763f",
//                 "user": "65b8e564ea5ce114184ccb96",
//                 "item": [
//                     {
//                         "_id": "65c266dab53f820728d07632",
//                         "user": "65b8e564ea5ce114184ccb96",
//                         "product": {
//                             "_id": "65a7e45902e12c44f59944ae",
//                             "title": "Metal Ceramic Flower",
//                             "description": "Metal Ceramic Flower Chandelier Home Lighting American Vintage Hanging Lighting Pendant Lamp",
//                             "price": 35,
//                             "discountPercentage": 10.94,
//                             "stockQuantity": 146,
//                             "brand": {
//                                 "_id": "65a7e20102e12c44f5994425",
//                                 "name": "Ifei Home"
//                             },
//                             "category": "65a7e24602e12c44f599443f",
//                             "thumbnail": "https://cdn.dummyjson.com/product-images/97/thumbnail.jpg",
//                             "images": [
//                                 "https://cdn.dummyjson.com/product-images/97/1.jpg",
//                                 "https://cdn.dummyjson.com/product-images/97/2.jpg",
//                                 "https://cdn.dummyjson.com/product-images/97/3.jpg",
//                                 "https://cdn.dummyjson.com/product-images/97/4.webp",
//                                 "https://cdn.dummyjson.com/product-images/97/thumbnail.jpg"
//                             ],
//                             "isDeleted": false
//                         },
//                         "quantity": 4
//                     }
//                 ],
//                 "address": [
//                     {
//                         "_id": "65c26398e1e1a2106ac8fbd5",
//                         "user": "65b8e564ea5ce114184ccb96",
//                         "street": "main 11th",
//                         "city": "Indrapuram",
//                         "state": "Uttar Pradesh",
//                         "phoneNumber": "9452571272",
//                         "postalCode": "201012",
//                         "country": "India",
//                         "type": "Home",
//                         "__v": 0
//                     }
//                 ],
//                 "status": "Pending",
//                 "paymentMode": "COD",
//                 "total": 150.55,
//                 "createdAt": "2024-02-07T10:36:15.151Z"
//             },
//             {
//                 "_id": "692b2bcd48bd0d133f3e1a33",
//                 "user": "65b8e564ea5ce114184ccb96",
//                 "item": [
//                     {
//                         "_id": "65c357fe2f21c40d167c276b",
//                         "user": "65b8e564ea5ce114184ccb96",
//                         "product": {
//                             "_id": "65a7e45902e12c44f5994453",
//                             "title": "MacBook Pro",
//                             "description": "MacBook Pro 2021 with mini-LED display may launch between September, November",
//                             "price": 1749,
//                             "discountPercentage": 11.02,
//                             "category": "65a7e24602e12c44f599442d",
//                             "brand": {
//                                 "_id": "65a7e20102e12c44f59943da",
//                                 "name": "Apple",
//                                 "__v": 0
//                             },
//                             "stockQuantity": 83,
//                             "thumbnail": "https://cdn.dummyjson.com/product-images/6/thumbnail.png",
//                             "images": [
//                                 "https://cdn.dummyjson.com/product-images/6/1.png",
//                                 "https://cdn.dummyjson.com/product-images/6/2.jpg",
//                                 "https://cdn.dummyjson.com/product-images/6/3.png",
//                                 "https://cdn.dummyjson.com/product-images/6/4.jpg"
//                             ],
//                             "isDeleted": false,
//                             "updatedAt": "2024-02-07T09:22:57.840Z",
//                             "createdAt": "2025-11-29T16:22:52.594Z"
//                         },
//                         "quantity": 1
//                     },
//                     {
//                         "_id": "65c3581d2f21c40d167c278f",
//                         "user": "65b8e564ea5ce114184ccb96",
//                         "product": {
//                             "_id": "65a7e45902e12c44f599445d",
//                             "title": "Hyaluronic Acid Serum",
//                             "description": "L'OrÃ©al Paris introduces Hyaluron Expert Replumping Serum formulated with 1.5% Hyaluronic Acid",
//                             "price": 19,
//                             "discountPercentage": 13.31,
//                             "category": "65a7e24602e12c44f599442f",
//                             "brand": {
//                                 "_id": "65a7e20102e12c44f59943e6",
//                                 "name": "L'Oreal Paris",
//                                 "__v": 0
//                             },
//                             "stockQuantity": 110,
//                             "thumbnail": "https://cdn.dummyjson.com/product-images/16/thumbnail.jpg",
//                             "images": [
//                                 "https://cdn.dummyjson.com/product-images/16/1.png",
//                                 "https://cdn.dummyjson.com/product-images/16/2.webp",
//                                 "https://cdn.dummyjson.com/product-images/16/3.jpg",
//                                 "https://cdn.dummyjson.com/product-images/16/4.jpg",
//                                 "https://cdn.dummyjson.com/product-images/16/thumbnail.jpg"
//                             ],
//                             "isDeleted": false,
//                             "updatedAt": "2024-02-07T09:22:57.840Z",
//                             "createdAt": "2025-11-29T16:22:52.595Z"
//                         },
//                         "quantity": 4
//                     },
//                     {
//                         "_id": "65c3584f2f21c40d167c27f5",
//                         "user": "65b8e564ea5ce114184ccb96",
//                         "product": {
//                             "_id": "65a7e45902e12c44f59944a1",
//                             "title": "Square Sunglasses",
//                             "description": "Fashion Oversized Square Sunglasses Retro Gradient Big Frame Sunglasses For Women One Piece Gafas Shade Mirror Clear Lens 17059",
//                             "price": 28,
//                             "discountPercentage": 13.89,
//                             "category": "65a7e24602e12c44f599443c",
//                             "brand": {
//                                 "_id": "65a7e20102e12c44f599441a",
//                                 "name": "mastar watch",
//                                 "__v": 0
//                             },
//                             "stockQuantity": 64,
//                             "thumbnail": "https://cdn.dummyjson.com/product-images/84/thumbnail.jpg",
//                             "images": [
//                                 "https://cdn.dummyjson.com/product-images/84/1.jpg",
//                                 "https://cdn.dummyjson.com/product-images/84/2.jpg",
//                                 "https://cdn.dummyjson.com/product-images/84/thumbnail.jpg"
//                             ],
//                             "isDeleted": false,
//                             "updatedAt": "2024-02-07T09:22:57.840Z",
//                             "createdAt": "2025-11-29T16:22:52.602Z"
//                         },
//                         "quantity": 2
//                     },
//                     {
//                         "_id": "692b20d604589e4cdeca4bce",
//                         "user": "65b8e564ea5ce114184ccb96",
//                         "product": {
//                             "_id": "65a7e45902e12c44f599444f",
//                             "title": "Fog Scent Xpressio Perfume custom",
//                             "description": "Product details of Best Fog Scent Xpressio Perfume 100ml For Men cool long lasting perfumes for Men",
//                             "price": 13,
//                             "discountPercentage": 8.14,
//                             "category": "65a7e24602e12c44f599442e",
//                             "brand": {
//                                 "_id": "65a7e20102e12c44f59943e3",
//                                 "name": "Fog Scent Xpressio",
//                                 "__v": 0
//                             },
//                             "stockQuantity": 21,
//                             "thumbnail": "https://cdn.dummyjson.com/product-images/13/thumbnail.webp",
//                             "images": [
//                                 "https://cdn.dummyjson.com/product-images/13/1.jpg",
//                                 "https://cdn.dummyjson.com/product-images/13/2.png",
//                                 "https://cdn.dummyjson.com/product-images/13/3.jpg",
//                                 "https://cdn.dummyjson.com/product-images/13/4.jpg"
//                             ],
//                             "isDeleted": false,
//                             "updatedAt": "2024-02-07T09:22:57.840Z",
//                             "createdAt": "2025-11-29T16:22:52.594Z"
//                         },
//                         "quantity": 1
//                     },
//                     {
//                         "_id": "692b28d748bd0d133f3e1902",
//                         "user": "65b8e564ea5ce114184ccb96",
//                         "product": {
//                             "_id": "65a7e45902e12c44f599444e",
//                             "title": "iPhone 9",
//                             "description": "An apple mobile which is nothing like apple",
//                             "price": 549,
//                             "discountPercentage": 12.96,
//                             "category": "65a7e24602e12c44f599442c",
//                             "brand": {
//                                 "_id": "65a7e20102e12c44f59943da",
//                                 "name": "Apple",
//                                 "__v": 0
//                             },
//                             "stockQuantity": 14,
//                             "thumbnail": "https://cdn.dummyjson.com/product-images/1/thumbnail.jpg",
//                             "images": [
//                                 "https://cdn.dummyjson.com/product-images/1/1.jpg",
//                                 "https://cdn.dummyjson.com/product-images/1/2.jpg",
//                                 "https://cdn.dummyjson.com/product-images/1/3.jpg",
//                                 "https://cdn.dummyjson.com/product-images/1/4.jpg",
//                                 "https://cdn.dummyjson.com/product-images/1/thumbnail.jpg"
//                             ],
//                             "isDeleted": false,
//                             "updatedAt": "2024-02-07T09:22:57.840Z",
//                             "createdAt": "2025-11-29T16:22:52.593Z"
//                         },
//                         "quantity": 1
//                     }
//                 ],
//                 "address": [
//                     {
//                         "_id": "65c26398e1e1a2106ac8fbd5",
//                         "user": "65b8e564ea5ce114184ccb96",
//                         "street": "main 11th",
//                         "city": "Indrapuram",
//                         "state": "Uttar Pradesh",
//                         "phoneNumber": "9452571272",
//                         "postalCode": "201012",
//                         "country": "India",
//                         "type": "Home",
//                         "__v": 0
//                     }
//                 ],
//                 "status": "Pending",
//                 "paymentMode": "COD",
//                 "total": 2453.55,
//                 "createdAt": "2025-11-29T17:22:21.553Z"
//             }
//         ]
//     }
// }

export const getOrderByUserId = async (userId) => {
    try {
      const db = getFirestore();
      const q = query(
        collection(db, "orders"),
        where("user", "==", userId)
      );
  
      const querySnapshot = await getDocs(q);
  
      let orders = [];
      querySnapshot.forEach((doc) => {
        orders.push({ _id: doc.id, ...doc.data() });
      });
  
      // If no orders, return empty
      if (orders.length === 0) return [];
  
      return orders;
  
    } catch (error) {
      console.error("Error fetching orders:", error);
  
      // fallback demo data
      return [
        {
          "_id": "65c2658db53f820728d0745a",
          "user": "65b8e564ea5ce114184ccb96",
          "item": [
            {
              "user": "65b8e564ea5ce114184ccb96",
              "product": {
                "_id": "65a7e45902e12c44f5994454",
                "title": "Samsung Galaxy Book",
                "description": "Samsung Galaxy Book S...",
                "price": 1499,
                "discountPercentage": 4.15,
                "stockQuantity": 50,
                "brand": { "name": "Samsung" },
                "thumbnail": "https://cdn.dummyjson.com/product-images/7/thumbnail.jpg",
                "images": [
                  "https://cdn.dummyjson.com/product-images/7/1.jpg",
                  "https://cdn.dummyjson.com/product-images/7/2.jpg"
                ]
              },
              "quantity": 1
            }
          ],
          "address": [
            {
              "street": "main 11th",
              "city": "Indrapuram",
              "state": "Uttar Pradesh",
              "phoneNumber": "9452571272",
              "postalCode": "201012",
              "country": "India"
            }
          ],
          "status": "Delivered"
        }
      ];
    }
  };


// export const getAllOrders=async()=>{
//     try {
//         const res=await axiosi.get(`/orders`)
//         return res.data
//     } catch (error) {
//         throw error.response.data
//     }
// }

// export const getAllOrders = async () => {
//     try {
//       const db = getFirestore();
  
//       const querySnapshot = await getDocs(collection(db, "orders"));
  
//       let orders = [];
//       querySnapshot.forEach((doc) => {
//         orders.push({ _id: doc.id, ...doc.data() });
//       });
  
//       return orders;
  
//     } catch (error) {
//       console.error("Error fetching all orders:", error);
//       throw error;
//     }
//   };

// export const getAllOrders = async () => {
//   try {
//     const db = getFirestore();

//     // 🔥 Latest orders first + only first 5
//     const ordersQuery = query(
//       collection(db, "orders"),
//       orderBy("createdAt", "desc"),
//       // limit(10)
//     );

//     const ordersSnap = await getDocs(ordersQuery) //await getDocs(collection(db, "orders"));

//     let orders = [];

//     for (let orderDoc of ordersSnap.docs) {
//       const orderData = orderDoc.data();

//       // ---- Convert Timestamp (Firestore → JS Date)
//       const createdAt = orderData.createdAt?.toDate
//         ? orderData.createdAt.toDate()
//         : new Date();

//       // ---- 1. Populate User
//       let user = null;

//       if (orderData.user) {
//         const userRef = doc(db, "users", orderData.user);
//         const userSnap = await getDoc(userRef);

//         if (userSnap.exists()) {
//           user = { _id: userSnap.id, ...userSnap.data() };
//         }
//       }

//       // ---- 2. Populate Items
//       let populatedItems = [];

//       for (let item of orderData.item || []) {
//         // Get Product
//         const productRef = doc(db, "products", item.product._id);
//         const productSnap = await getDoc(productRef);

//         let product = null;
//         let brand = null;

//         if (productSnap.exists()) {
//           product = { _id: productSnap.id, ...productSnap.data() };

//           // Populate Brand
//           if (product.brand) {
//             const brandRef = doc(db, "brands", product.brand);
//             const brandSnap = await getDoc(brandRef);

//             if (brandSnap.exists()) {
//               brand = { _id: brandSnap.id, ...brandSnap.data() };
//             }
//             // console.log('ff',brand)
//           }
//         }

//         populatedItems.push({
//           _id: item._id,
//           user: item.user,
//           quantity: item.quantity,
//           product: product ? { ...product, brand } : null
//         });
//       }

//       // ---- 3. Normalize Address Format  
//       const address = Array.isArray(orderData.address)
//         ? orderData.address
//         : [orderData.address];

//       // ---- 4. Push Final Fully Populated Order  
//       orders.push({
//         _id: orderDoc.id,
//         users: user, // FULL POPULATED USER OBJECT
//         user: user._id,
//         item: populatedItems,
//         address,
//         status: orderData.status,
//         paymentMode: orderData.paymentMode,
//         total: orderData.total,
//         createdAt: createdAt.toISOString()
//       });
//       // console.log('ff', orders)

//     }
//     // console.log('ff', orders)
//     return orders;

//   } catch (error) {
//     console.error("Error fetching orders:", error);
//     throw error;
//   }
// };

const getCollectionById = (id) => {
  if (id.startsWith("guest-")) return "guests";
  return "users";
};

export const getAllOrders = async () => {
  try {
    const db = getFirestore();

    const ordersQuery = query(
      collection(db, "orders"),
      orderBy("createdAt", "desc")
    );

    const ordersSnap = await getDocs(ordersQuery);

    let ordersRaw = [];
    let userIds = new Set();
    let productIds = new Set();
    let brandIds = new Set();

    // ------------------------------
    // 1. Collect all IDs
    // ------------------------------
    ordersSnap.forEach((doc) => {
      const data = doc.data();
      ordersRaw.push({ _id: doc.id, ...data });

      if (data.user) userIds.add(data.user);

      (data.item || []).forEach((i) => {
        if (i.product?._id) productIds.add(i.product._id);
      });
    });
    console.log('userid',userIds);
    // ------------------------------
    // 2. Fetch all Users in ONE batch
    // ------------------------------
    let users = {};
    // for (let id of userIds) {
    //   const snap = await getDoc(doc(db, "users", id));
    //   console.log('snap',snap.exists());
    //   if (snap.exists()) users[id] = { _id: snap.id, ...snap.data() };
      
    // }

    for (let id of userIds) {
      const snap = await getDoc(doc(db, getCollectionById(id), id));
      if (snap.exists()) {
        users[id] = { _id: snap.id, ...snap.data() };
      }
    }

    // ------------------------------
    // 3. Fetch all Products in ONE batch
    // ------------------------------
    let products = {};
    for (let id of productIds) {
      const snap = await getDoc(doc(db, "products", id));
      if (snap.exists()) {
        const p = { _id: snap.id, ...snap.data() };
        products[id] = p;
        if (p.brand) brandIds.add(p.brand);
      }
    }

    // ------------------------------
    // 4. Fetch all Brands in ONE batch
    // ------------------------------
    let brands = {};
    for (let id of brandIds) {
      const snap = await getDoc(doc(db, "brands", id));
      if (snap.exists()) brands[id] = { _id: snap.id, ...snap.data() };
    }

    // ------------------------------
    // 5. Build Final Orders (NO more queries)
    // ------------------------------
    let final = ordersRaw.map((ord) => ({
      _id: ord._id,
      users: users[ord.user] || null,
      address: Array.isArray(ord.address) ? ord.address : [ord.address],
      status: ord.status,
      user: ord.user,
      paymentMode: ord.paymentMode,
      total: ord.total,
      createdAt: ord.createdAt?.toDate
        ? ord.createdAt.toDate().toISOString()
        : new Date(ord.createdAt).toISOString(),

      item: (ord.item || []).map((i) => {
        const product = products[i.product?._id] || null;
        return {
          _id: i._id,
          quantity: i.quantity,
          user: i.user,
          size: i.size,
          color: i.color,
          product: product
            ? { ...product, brand: brands[product.brand] || null }
            : null
        };
      }),
    }));

    return final;

  } catch (error) {
    console.error("Error fetching orders:", error);
    throw error;
  }
};


// export const updateOrderById=async(update)=>{
//     try {
//         const res=await axiosi.patch(`/orders/${update._id}`,update)
//         return res.data
//     } catch (error) {
//         throw error.response.data
//     }
// }


// export const updateOrderById = async (update) => {
//     try {
//         const db = getFirestore();

//         const orderRef = doc(db, "orders", update._id);

//         await updateDoc(orderRef, update);

//         return { message: "Order updated successfully", ...update };

//     } catch (error) {
//         console.error("Error updating order:", error);
//         throw error;
//     }
// };


export const updateOrderById = async (update) => {
  try {
      const db = getFirestore();

      if (!update?._id) throw new Error("Order ID missing");

      const { _id, ...updateData } = update; // _id alag kar diya

      const orderRef = doc(db, "orders", _id);

      // Update only data (not _id)
      await updateDoc(orderRef, {
          ...updateData,
          updatedAt: new Date()
      });

      // Fetch updated order
      const snap = await getDoc(orderRef);

      return {
          message: "Order updated successfully",
          _id: snap.id,
          ...snap.data(),
      };

  } catch (error) {
      console.error("Error updating order:", error);
      throw new Error(error.message || "Failed to update order");
  }
};



